export default __webpack_public_path__ + "static/media/Beta-banner2.f8e45f49.png";